import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=3dc72e93&scoped=true&"
import script from "./loader.vue?vue&type=script&lang=js&"
export * from "./loader.vue?vue&type=script&lang=js&"
import style0 from "./loader.vue?vue&type=style&index=0&id=3dc72e93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc72e93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VProgressLinear})
